// import TweenLite from './vendor/TweenLite';
import Preloader from './preloader';
import Intro from './intro';
import Question from './question';
import Results from './results';

let Application = function (params) {
  if (Application.prototype._singletonInstance) {
    return Application.prototype._singletonInstance;
  }
  Application.prototype._singletonInstance = this;

  this.initialize(params);
};

Application.prototype.initialize = function (params) {
  // console.log('Application initalizing ' + params);

  Application.tweenLength = 0.5;
  Application.tweenStagger = "-=0.25";

  /**
   *
   */
  let self = this;
  this.preloader = new Preloader({});
  this.intro = new Intro({});
  this.question1 = new Question({elementId: 'question-1'});
  this.question2 = new Question({elementId: 'question-2'});
  this.question3 = new Question({elementId: 'question-3'});
  this.question4 = new Question({elementId: 'question-4'});
  this.question5 = new Question({elementId: 'question-5'});
  this.question6 = new Question({elementId: 'question-6'});
  this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6];
  this.results = new Results({});

  // Current screen/state info
  // preloader, intro, question, results
  this.currentState = "preloader";
  this.currentQuestion = 0;
  this.totalQuestions = 6;

  // Scoring info
  // array of html element ids that have data attributes that are used to calculate final results
  this.answers = [];
  this.score_t300 = 0;
  this.score_t200 = 0;
  this.score_t100 = 0;
  this.score_620cb = 0;
  this.score_620mb = 0;

  // this.open = function() {
  //   console.log('Application.open');
  // };

  this.preloaderClosed = function () {
    this.intro.open();
    this.currentState = "intro";
  };

  this.introClosed = function () {
    this.scrollToTopOfPage();
    this.question1.open();
    this.currentState = "question";
    this.currentQuestion = 1;

    // test values:
    // this.results.open();
    // this.question6.open();
    // this.currentState = "question";
    // this.currentQuestion = 6;
  };

  this.questionClosed = function (direction) {
    if ( direction > 0 ) {
      // next question or results
      this.currentQuestion++;
    } else {
      // previous question or intro
      this.currentQuestion--;
    }
    console.log('Application.questionClosed opening question ' + this.currentQuestion);
    // console.log('this.currentQuestion === 0 ' + (this.currentQuestion === 0));
    this.scrollToTopOfPage();
    if (this.currentQuestion === 0) {
      this.intro.open();
    } else if (this.currentQuestion === this.totalQuestions + 1) {
      //show results
      // console.log("TODO RESULTS");
      this.results.open();
      this.currentState = "results";
      // this.currentQuestion = 0;
      // this.intro.open();

    } else {
      this.questions[this.currentQuestion - 1].open();
    }
  };

  this.storeAnswer = function (answerId) {
    this.answers[this.currentQuestion - 1] =  answerId;
    console.log('history is ', this.answers);
  };

  this.calculateResults = function () {
    let answerId;
    let answerElement;
    this.score_t100 = 0;
    this.score_t200 = 0;
    this.score_t300 = 0;
    this.score_620cb = 0;
    this.score_620mb = 0;
    for (let x = 0; x < this.answers.length; x++) {
      answerElement = document.getElementById(this.answers[x]);
      this.score_t100 += parseInt(answerElement.getAttribute('data-t100'), 10);
      this.score_t200 += parseInt(answerElement.getAttribute('data-t200'), 10);
      this.score_t300 += parseInt(answerElement.getAttribute('data-t300'), 10);
      this.score_620cb += parseInt(answerElement.getAttribute('data-620cb'), 10);
      this.score_620mb += parseInt(answerElement.getAttribute('data-620mb'), 10);
      console.log('');
      console.log('Question ' + x + ' score totals:');
      console.log('t100: ' + this.score_t100);
      console.log('t200: ' + this.score_t200);
      console.log('t300: ' + this.score_t300);
      console.log('620cb: ' + this.score_620cb);
      console.log('620mb: ' + this.score_620mb);
    }

    let scores = { 't100' : this.score_t100, 't200' : this.score_t200, 't300' : this.score_t300, '620cb' : this.score_620cb, '620mb' : this.score_620mb };
    let sortedScores = Object.keys(scores).sort(function(a,b){return scores[b]-scores[a]});
    console.log("final sorted score results: ", sortedScores);

    // let ironKeys = Object.keys(sortedScores);
    // console.log('keys are ', ironKeys);
    // let ironId = ironKeys[0];
    // let ironId = sortedScores[0];
    // return ironId;

    return sortedScores;
  };

  this.reset = function() {
    this.currentQuestion = 0;
    this.intro.open();
    this.scrollToTopOfPage();
  };

  this.scrollToTopOfPage = function() {
    try {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      });
    } catch(e) {
      console.log('scroll to top error');
    }
    try {
      window.parent.parent.scrollTo({
        top: 0,
        behavior: 'auto'
      });
    } catch(e) {
      console.log('scroll to top error');
    }
  };

};

export default Application;

